import { i as c, e as d } from "./directive-B76A7YXI.js";
import { g as E } from "./uid-HAKIZOcY.js";
const s = class s extends c {
  constructor() {
    super(...arguments), this.uuid = E(), this.slotHasEvent = !1, this.usingParentElement = !1, this.containerSelector = "", this.totalSlottedElements = 0, this.handleSlotchange = (a) => {
      if (a.eventPhase !== 2)
        return;
      const t = a.target, i = t == null ? void 0 : t.assignedElements();
      let e;
      this.totalSlottedElements = i.length, this.containerSelector ? e = this.findContainerElement(t) : e = this.usingParentElement ? t.parentElement : t, this.totalSlottedElements < 1 ? (e == null || e.classList.add(s.defaultClassName), e == null || e.classList.remove(this.hasSlottedClassName)) : (e == null || e.classList.remove(s.defaultClassName), e == null || e.classList.add(this.hasSlottedClassName));
    };
  }
  get hasSlottedClassName() {
    return `has-slotted-${this.uuid}`;
  }
  findContainerElement(a) {
    if (this.containerSelector)
      return a.closest(this.containerSelector);
  }
  /** Create and append a small set of styles when the directive is used. */
  static createStyleElement(a) {
    const t = document.createElement("style");
    t.innerHTML = `.${s.defaultClassName}:not([class*='has-slotted-']) {display: none !important;}`, t.id = s.stylesID, a.appendChild(t);
  }
  update(a, [t = { useParent: !1 }]) {
    const { useParent: i, container: e } = t, n = a.element, o = n.getRootNode(), { parentElement: h } = n;
    i && (this.usingParentElement = !0), e && (this.containerSelector = e);
    const l = {};
    return this.containerSelector ? l.element = this.findContainerElement(n) : i && h ? l.element = h : l.element = n, o.querySelector(`#${s.stylesID}`) || s.createStyleElement(o), this.slotHasEvent || (n.addEventListener("slotchange", this.handleSlotchange), this.slotHasEvent = !0), this.render(l);
  }
  /**
   * The directive takes a single object parameter. If your slot has a parent that dictates styling, then set `useParent` to true. The element to be updated will be handled automatically as either the parent element or the slot directly, but if you have a case where the element you need to hide is higher up, you can pass an HTML element reference into the object.
   *
   * ```ts
   * html`<div class="slot-wrapper">
   *    <slot ${showIfUsed({useParent: true})}></slot>
   * </div>`
   *
   * html`<slot ${showIfUsed()}></slot>`
   * ```
   */
  render({ useParent: a, element: t } = { useParent: !1 }) {
    t && this.totalSlottedElements < 1 && (t.classList.add(s.defaultClassName), t.classList.remove(this.hasSlottedClassName)), t && this.totalSlottedElements >= 1 && t.classList.add(this.hasSlottedClassName);
  }
};
s.defaultClassName = "hide-slot-area", s.stylesID = "show-if-used-directive-styles";
let r = s;
const f = d(r);
export {
  f as s
};
